export default function LoadingScreen() {
  return (
    <div className="min-h-screen bg-dark-950 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="spinner w-8 h-8" />
        <p className="text-dark-400 text-sm">Loading...</p>
      </div>
    </div>
  );
}
